const root = state => state.getIn(['users']);
const entities = state => root(state).get('entities'); // TODO: Remove?
export const users = state => entities(state);
export const userById = (state, id) => users(state).get(String(id));
export const usersByIds = (state, ids) => ids.map(id => userById(state, id));
